(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mi-experience"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('[data-mi-scroll-section], [data-mi-reveal], [data-mi-tilt], [data-mi-motion-toggle]')) return

    if (window.MontfortExperience) {
      window.MontfortExperience.refresh()
      return
    }

    const root = document.documentElement
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    const forcedReduction = () => Boolean(reduceMotion.matches || connection?.saveData || /^(slow-2g|2g|3g)$/.test(connection?.effectiveType || ''))
    let userPaused = false
    let frame = 0
    let scrollSections = []
    let observer

    try {
      userPaused = localStorage.getItem('montfort-motion') === 'paused'
    } catch (error) {
      userPaused = false
    }

    const isMotionOff = () => userPaused || forcedReduction()

    const updateControls = () => {
      const off = isMotionOff()
      root.classList.toggle('mi-motion-off', off)
      root.dataset.miMotion = off ? 'paused' : 'running'
      document.querySelectorAll('[data-mi-motion-toggle]').forEach(button => {
        const forced = forcedReduction()
        const label = forced ? button.dataset.reducedLabel : off ? button.dataset.playLabel : button.dataset.pauseLabel
        button.setAttribute('aria-pressed', off ? 'true' : 'false')
        button.setAttribute('aria-disabled', forced ? 'true' : 'false')
        button.setAttribute('aria-label', label)
        button.title = label
        const text = button.querySelector('.mi-motion-toggle__label')
        if (text) text.textContent = label
      })
    }

    const clamp = value => Math.min(1, Math.max(0, value))

    const updateProgress = () => {
      frame = 0
      const viewport = window.innerHeight || 1
      const documentTravel = Math.max(1, document.documentElement.scrollHeight - viewport)
      root.style.setProperty('--mi-page-progress', clamp(window.scrollY / documentTravel).toFixed(4))

      scrollSections.forEach(section => {
        if (isMotionOff()) {
          section.style.setProperty('--mi-progress', '1')
          section.style.setProperty('--mi-local', '1')
          const portalContent = section.matches('[data-mi-portal]') ? section.querySelector('.mi-portal__content') : null
          if (portalContent) {
            portalContent.inert = false
            portalContent.removeAttribute('aria-hidden')
          }
          return
        }

        const rect = section.getBoundingClientRect()
        const travel = Math.max(1, rect.height - viewport)
        const portalProgress = clamp(-rect.top / travel)
        const localProgress = clamp((viewport - rect.top) / Math.max(1, viewport + rect.height))
        section.style.setProperty('--mi-progress', portalProgress.toFixed(4))
        section.style.setProperty('--mi-local', localProgress.toFixed(4))

        if (section.matches('[data-mi-portal]')) {
          const portalContent = section.querySelector('.mi-portal__content')
          if (portalContent) {
            const contentIsAvailable = portalProgress >= .78
            portalContent.inert = !contentIsAvailable
            if (contentIsAvailable) portalContent.removeAttribute('aria-hidden')
            else portalContent.setAttribute('aria-hidden', 'true')
          }
        }
      })
    }

    const requestUpdate = () => {
      if (frame) return
      frame = requestAnimationFrame(updateProgress)
    }

    const bindTilt = element => {
      if (element.dataset.miTiltBound === 'true') return
      element.dataset.miTiltBound = 'true'
      element.addEventListener('pointermove', event => {
        if (isMotionOff() || !window.matchMedia('(pointer: fine)').matches) return
        const rect = element.getBoundingClientRect()
        const x = ((event.clientX - rect.left) / rect.width - .5) * 2
        const y = ((event.clientY - rect.top) / rect.height - .5) * 2
        element.style.setProperty('--mi-tilt-x', (x * 1.25).toFixed(2))
        element.style.setProperty('--mi-tilt-y', (y * 1.25).toFixed(2))
      })
      element.addEventListener('pointerleave', () => {
        element.style.setProperty('--mi-tilt-x', '0')
        element.style.setProperty('--mi-tilt-y', '0')
      })
    }

    const refresh = () => {
      scrollSections = Array.from(document.querySelectorAll('[data-mi-scroll-section]'))
      if (observer) observer.disconnect()
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mi-in-view')
            observer.unobserve(entry.target)
          }
        })
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 })
      document.querySelectorAll('[data-mi-reveal]').forEach(element => {
        if (element.dataset.miRevealOrder) element.style.setProperty('--mi-order', Math.max(0, Number(element.dataset.miRevealOrder) - 1))
        if (isMotionOff()) element.classList.add('mi-in-view')
        else observer.observe(element)
      })
      document.querySelectorAll('[data-mi-tilt]').forEach(bindTilt)
      requestUpdate()
    }

    document.addEventListener('click', event => {
      const skip = event.target.closest('[data-mi-skip]')
      if (skip) {
        const portal = skip.closest('[data-mi-portal]')
        if (portal) {
          window.scrollTo({ top: portal.offsetTop + portal.offsetHeight, behavior: isMotionOff() ? 'auto' : 'smooth' })
        }
        return
      }

      const toggle = event.target.closest('[data-mi-motion-toggle]')
      if (!toggle || forcedReduction()) return

      const portal = document.querySelector('[data-mi-portal]')
      const oldHeight = portal?.offsetHeight || 0
      const portalTop = portal?.offsetTop || 0
      const wasBelow = Boolean(portal && window.scrollY >= portalTop + oldHeight - 2)
      const rect = portal?.getBoundingClientRect()
      const wasInside = Boolean(rect && rect.top <= 0 && rect.bottom > window.innerHeight)
      const insideProgress = wasInside ? clamp(-rect.top / Math.max(1, rect.height - window.innerHeight)) : 0

      userPaused = !userPaused
      try {
        localStorage.setItem('montfort-motion', userPaused ? 'paused' : 'running')
      } catch (error) {}
      updateControls()

      requestAnimationFrame(() => {
        if (!portal) return
        const heightChange = portal.offsetHeight - oldHeight
        if (wasBelow) window.scrollBy(0, heightChange)
        else if (userPaused && wasInside) window.scrollTo(0, portal.offsetTop + (insideProgress > .55 ? portal.offsetHeight : 0))
        requestUpdate()
      })
    })

    window.addEventListener('scroll', requestUpdate, { passive: true })
    window.addEventListener('resize', requestUpdate, { passive: true })
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) requestUpdate()
    })
    document.addEventListener('shopify:section:load', refresh)
    reduceMotion.addEventListener?.('change', () => {
      updateControls()
      refresh()
    })
    connection?.addEventListener?.('change', () => {
      updateControls()
      refresh()
    })

    root.classList.remove('no-js')
    root.classList.add('js')
    window.MontfortExperience = { refresh, updateControls }
    updateControls()
    refresh()
  })()
  } catch(e) { console.error(e); }
})();

})();
